import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateUserList = {
  userList: { data: null, loading: false, error: null },
};

export const userList = createAsyncThunk('user/userList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/user/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserList = {
  [userList.pending]: (state) => {
    state.userList.loading = true;
  },
  [userList.fulfilled]: (state, action) => {
    state.userList.loading = false;
    state.userList.data = action.payload;
    state.userList.error = null;
  },
  [userList.rejected]: (state, action) => {
    state.userList.data = null;
    state.userList.loading = false;
    state.userList.error = action.payload;
  },
};
